import { Form } from 'factorial-form'

class LeaveTypeForm extends Form {
  constructor(values: object) {
    super(values, {
      name: 'string',
      description: 'string',
      color: 'string',
      accrues: 'boolean',
      visibility: 'boolean',
      attachment: 'boolean',
      is_attachment_mandatory: 'boolean',
      approval_required: 'boolean',
      workable: 'boolean',
      payable: 'boolean',
      half_days_units_enabled: 'boolean',
      max_days_in_cents: 'cents',
      min_days_in_cents: 'cents',
      allow_endless: 'boolean',
      restricted: 'boolean',
      details_required: 'boolean',
    })
  }

  get hasAttachment(): boolean {
    return this.get('attachment').value === 'true' || this.get('attachment').value === true
  }

  VALUES_TO_CHECK = [
    'accrues',
    'approval_required',
    'attachment',
    'name',
    'visibility',
    'workable',
    'payable',
    'allow_endless',
    'restricted',
    'details_required',
  ]

  get isLeaveTypeFormComplete() {
    for (const v of this.VALUES_TO_CHECK) {
      if (this.get(v).value === null || this.get(v).value === '') {
        return false
      }
    }
    return true
  }

  get isLeaveTypeNameValid() {
    return this.get('name').value !== ''
  }
}

export default LeaveTypeForm
